import { calculateSumOfCurrencyColumnInCents } from '../../../utils/Table.utils';
import { toCents } from '../../../utils/Money.utils';
import { FieldModel } from '../extraction-models';
import { DataAwareValidator } from '../../domain-extraction-specifications';
import { Validations } from '@ps-gui/ui';
import { CtBatchSource } from '@ps-gui/claims-terminal-shared';
import { FieldType } from '@ps-gui/shared-utils';

export const Kopfdaten = {
  kopfdaten_schadennummer: {
    key: 'kopfdaten_schadennummer',
    label: { text: 'Schadennummer', genus: 'F' },
    type: FieldType.STRING,
    index: 0,
    visibleForSource: [CtBatchSource.NEW_BACKEND],
    validators: [Validations.required()],
  },
  kopfdaten_kennung: {
    key: 'kopfdaten_kennung',
    label: { text: 'Kennung', genus: 'F' },
    type: FieldType.STRING,
    index: 1,
    visibleForSource: [CtBatchSource.NEW_BACKEND],
    validators: [],
  },
  kopfdaten_schadendatum: {
    key: 'kopfdaten_schadendatum',
    label: { text: 'Schadendatum', genus: 'N' },
    type: FieldType.DATE,
    index: 2,
    onlyVisibleInConsolidation: true,
    validators: [Validations.date()],
  },
  kopfdaten_forderungsdatum: {
    key: 'kopfdaten_forderungsdatum',
    label: { text: 'Forderungsdatum', genus: 'N' },
    type: FieldType.DATE,
    index: 3,
    validators: [Validations.date()],
  },
  kopfdaten_geburtsdatum: {
    key: 'kopfdaten_geburtsdatum',
    label: { text: 'Geburtsdatum betroffene Person', genus: 'N' },
    type: FieldType.DATE,
    index: 4,
    validators: [Validations.date()],
  },
  kopfdaten_kostentraegerzeichen: {
    key: 'kopfdaten_kostentraegerzeichen',
    label: { text: 'Zeichen Kostenträger', genus: 'N' },
    type: FieldType.STRING,
    index: 5,
  },
  // TODO: Temporary until separated in a different class
  kopfdaten_vorname_betroffene_person: {
    key: 'kopfdaten_vorname_betroffene_person',
    label: { text: 'Vorname betroffene Person', genus: 'M' },
    type: FieldType.STRING,
    onlyVisibleInConsolidation: true,
    index: 6,
  },
  kopfdaten_nachname_betroffene_person: {
    key: 'kopfdaten_nachname_betroffene_person',
    label: { text: 'Nachname betroffene Person', genus: 'M' },
    type: FieldType.STRING,
    onlyVisibleInConsolidation: true,
    index: 7,
  },
  kopfdaten_gesamtbetrag: {
    key: 'kopfdaten_gesamtbetrag',
    label: { text: 'Forderungssumme', genus: 'F' },
    type: FieldType.CURRENCY,
    index: 8,
    dataAwareValidator: (control, extractedRowFormProvider) => {
      return (_) => {
        const rowFormArray = extractedRowFormProvider();
        if (
          rowFormArray === undefined ||
          control.value === undefined ||
          control.value === null ||
          control.value === ''
        )
          return null;
        const sumInCents = calculateSumOfCurrencyColumnInCents(
          rowFormArray.getRawValue(),
          'forderungen_betrag',
        );
        if (sumInCents === toCents(Number(control.value))) return null;

        return {
          divergingSum: true,
        };
      };
    },
  },
  kopfdaten_vyda_nachricht: {
    key: 'kopfdaten_vyda_nachricht',
    label: { text: 'Nachricht an VYDA', genus: 'F' },
    type: FieldType.TEXTAREA,
    index: 9,
    visibleForSource: [CtBatchSource.NEW_BACKEND],
    validators: [],
  },
} satisfies Record<string, FieldModel & { dataAwareValidator?: DataAwareValidator }>;
